import * as React from 'react';
import { DropdownPopover, Outside, ArticleParagraph1 } from '@cian/ui-kit';
import { IconActionSort16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './SortingDesktop.css';
import { ISortingProps } from '../../types';

import { SortingDesktopDropdown } from '../SortingDesktopDropdown';

export const SortingDesktop: React.FC<ISortingProps> = ({
  disabled,
  onChange,
  options,
  placeholder,
  selectedOption,
}) => {
  const [isOpenDropdown, setIsOpenDropdown] = React.useState(false);

  const dropdownRef = React.useRef<HTMLUListElement>(null);
  const buttonRef = React.useRef<HTMLButtonElement>(null);

  const openDropdown = React.useCallback(() => {
    setIsOpenDropdown(true);
  }, []);

  const closeDropdown = React.useCallback(() => {
    setIsOpenDropdown(false);

    if (buttonRef.current) {
      buttonRef.current.focus();
    }
  }, []);

  return (
    <Outside onOutside={closeDropdown} active={isOpenDropdown} insideRefs={[dropdownRef]}>
      <div>
        <DropdownPopover
          open={isOpenDropdown}
          content={
            <SortingDesktopDropdown
              dropdownRef={dropdownRef}
              onChange={onChange}
              onClose={closeDropdown}
              selectedOption={selectedOption}
              options={options}
            />
          }
        >
          <button
            ref={buttonRef}
            className={styles['sort-button']}
            onClick={isOpenDropdown ? closeDropdown : openDropdown}
            disabled={disabled}
            type="button"
            aria-label="Сортировка"
            aria-haspopup="listbox"
          >
            <span className={styles['sort-icon']}>
              <IconActionSort16 color="current_color" />
            </span>
            <ArticleParagraph1 color="current_color" fontWeight="bold">
              {selectedOption ? selectedOption.label : placeholder}
            </ArticleParagraph1>
          </button>
        </DropdownPopover>
      </div>
    </Outside>
  );
};
